// npm packages
import React, { useState, useEffect, useContext, useRef } from "react";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

// custom pages
import "./qualityDashboard.css";
import config from "config/config";
import Context from "context/context";
import leftarrow from "assets/images/arrow-right.png";
import ReusableTable from "components/table/table";
import QualityDetails from "./qualityDetails";

// material ui
import { TextField, Autocomplete, Button,Box,Switch,FormControlLabel, CircularProgress } from "@mui/material";
import debounce from "lodash.debounce";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Tooltip from "@mui/material/Tooltip";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import { Breadcrumbs, Typography, Link } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Grid } from "../../../../../node_modules/@mui/material/index";

const QualityDashboard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [paramsId, setParamsId] = useState(null);
  const [filters, setFilters] = useState({
    practiceName: "",
    radName: "",
    modalityName: "",
    startDate: null,
    endDate: null,
  });

  const [filtersAccession, setFiltersAccession] = useState({
    practiceName: "",
    radName: "",
    modalityName: "",
    vraName:[],
    accessionNumbers: [],
    status: "New",
    startDate: null,
    endDate: null,
    isAuditedBySME:"No"
  });

  const [appliedFilters, setAppliedFilters] = useState({
    practiceName: "",
    radName: "",
    modalityName: "",
    startDate: null,
    endDate: null,
  });
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const firstRender = useRef(true);
  const firstRenderAccession = useRef(true);
  const firstRenderModality = useRef(true);
  const { state, dispatch } = useContext(Context);
  const navigate = useNavigate();

  const [practiceOptions, setPracticeOptions] = useState([]);
  const [radOptions, setRadOptions] = useState([]);
  const [modalityOptions, setModalityOptions] = useState([]);
  const [vraOptions, setVraOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableDataModal, setTableDataModal] = useState([]);
  const [count, setCount] = useState(0);
  const [modalitycount, setModalityCount] = useState(0);
  const [accessioncount, setAccessionCount] = useState(0);
  const [offset, setOffset] = useState(1);
  const [limit] = useState(30);
  const [searchValue, setSearchValue] = useState("");
  const [tableView, setTableView] = useState("main");
  const [detailsData, setDetailsData] = useState([]);
  const [modalityData, setModalityData] = useState([]);
  const [accessionData, setAccessionData] = useState([]);
  const [detailsOffset, setDetailsOffset] = useState(1);
  const [modalityOffset, setModalityOffset] = useState(1);
  const [accessionOffset, setAccessionOffset] = useState(1);
  const [filteraccessionOffset, setFilterAccessionOffset] = useState(1);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedRad, setSelectedRad] = useState(null);
  const [selectedAccession, setSelectedAccession] = useState(null);
  const [selectedAccessionItem, setSelectedAccessionItem] = useState({});
  const [receivedPractice, setreceivedPractice] = useState("");
  const location = useLocation();
  const [showFilters, setShowFilters] = useState(false);
  const [isFilterAccession, setIsFilterAccession] = useState(false);
  const [accessionOptions, setAccessionOptions] = useState([]);
const [loadingAccessions, setLoadingAccessions] = useState(false);
const [inputValue, setInputValue] = useState("");
const [accessionfilter,setAccessionfilter]=useState(false)
const statusOptions = ["New", "Completed"];
const isAuditedBySME = ["Yes", "No"];
const [vraFilterAccess,setVraFilterAccess]=useState(false)
const [accessionSno, setAccessionSno] = useState(null);

  useEffect(() => {
    fetchTableData();
  }, [offset]);


  const handleBreadcrumbClick = (view) => {
    if (view === "main") {
        setTableView("main");
        setDetailsOffset(1);
        setModalityOffset(1);
        setAccessionOffset(1);
        setFilters((prevFilters) => ({
            ...prevFilters,
            practiceName: "",
            radName: "",
            modalityName: "",
        }));
    } else if (view === "details") {
        setTableView("details");
        setModalityOffset(1);
        setAccessionOffset(1);
        // Only clear filters if not already in "details"
        if (tableView !== "details") {
            setFilters((prevFilters) => ({
                ...prevFilters,
                // radName: "",
                modalityName: "",
            }));
        }
    } else if (view === "modality") {
        if (tableView !== "modality") {
            setTableView("modality");
            setAccessionOffset(1);
        }
    }
};


  const fetchTableData = async () => {

    dispatch({ type: "SET_LOADING", payload: true });

    try {
      const apiUrl = `${config.host}/panel/quality-analyzer/data`;

      const queryPayload = isFilterApplied
        ? {
            offset: (offset - 1) * limit,
            limit,
            queryType: "PRACTICE",
            practiceName: filters.practiceName?.label || undefined,
            radiologistName: filters.radName?.label || undefined,
            modalityName: filters.modalityName?.label || undefined,
            startDate: filters.startDate
              ? dayjs(filters.startDate).format("YYYY-MM-DD")
              : dayjs().subtract(1, "day").format("YYYY-MM-DD"),
            endDate: filters.endDate
              ? dayjs(filters.endDate).format("YYYY-MM-DD")
              : dayjs().format("YYYY-MM-DD"),
          }
        : {
            offset: (offset - 1) * limit,
            limit,
            queryType: "PRACTICE",

            startDate: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
            endDate: dayjs().format("YYYY-MM-DD"),
          };
      const response = await fetch(
        `${apiUrl}?query=${JSON.stringify(queryPayload)}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Error fetching table data: ${response.status}`);
      }

      const data = await response.json();

      if (data.status === "Ok" && Array.isArray(data.data.data)) {
        const formattedData = data.data.data.map((item, index) => [
          index + 1 + (offset - 1) * limit,
          item.practiceName,
          item.radiologistCount,
          item.vraCount,
          
          item.modalityCount,
          item.accessionCount,
          item.accessionChangeCount,
          `${item.changePercentage}%`,
          `${item.overallPercentage}%`,
          <Tooltip title="View Details" key={index}>
            <span className="jobType">
              <RemoveRedEyeIcon
                style={{ color: "#E97000", cursor: "pointer" }}
                onClick={() => handleFetchDetailsData(item, 0)}
              />
            </span>
          </Tooltip>,
        ]);

        setTableDataModal(formattedData);
        setCount(data.data.count);
      } else {
        console.error("Unexpected response format:", data);
        setTableDataModal([]);
        setCount(0);
      }
    } catch (error) {
      console.error("Error fetching table data:", error);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false; // Mark first render as done
      return; // Exit effect on first render
    }

    if (detailsOffset !== null) {
      fetchDetailsData(filters);
    }
  }, [detailsOffset]);

  useEffect(()=>{
    console.log(tableView)
  },[tableView])

  const handleFetchDetailsData = (items) => {
    setFilters((prevFilters) => {
        const updatedFilters = {
            ...prevFilters,
            practiceName: items?.practiceName
                ? { label: items.practiceName, value: items.practiceName }
                : prevFilters?.practiceName,
        };

        fetchDetailsData(updatedFilters, items);
        return updatedFilters;
    });
};
const handleFetchDetailsDataFilters = (items) => {
  setFilters((prevFilters) => {
      const updatedFilters = {
          ...prevFilters,
          practiceName: items?.practiceName
              ? { label: items.practiceName?.label, value: items.practiceName?.label }
              : prevFilters?.practiceName,
      };

      fetchDetailsData(updatedFilters, items);
      return updatedFilters;
  });
};

  const fetchDetailsData = async (updatedFilters) => {
   
  
    dispatch({ type: "SET_LOADING", payload: true });

    try {
      const apiUrl = `${config.host}/panel/quality-analyzer/data`;

      const queryPayload = isFilterApplied
        ? {
            //   offset:newOffset,
            offset: (detailsOffset - 1) * limit,
            limit,
            queryType: "RADIOLOGIST",
            practiceName: updatedFilters.practiceName?.label || undefined,
                  radiologistName: updatedFilters.radName?.label || undefined,
                  modalityName: updatedFilters.modalityName?.label || undefined,
            startDate: filters.startDate
              ? dayjs(filters.startDate).format("YYYY-MM-DD")
              : dayjs().subtract(1, "day").format("YYYY-MM-DD"),
            endDate: filters.endDate
              ? dayjs(filters.endDate).format("YYYY-MM-DD")
              : dayjs().format("YYYY-MM-DD"),
          }
        : {
            // offset: newOffset,
            offset: (detailsOffset - 1) * limit,
            limit,
            queryType: "RADIOLOGIST",
            practiceName: updatedFilters.practiceName?.label || undefined,
            startDate: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
            endDate: dayjs().format("YYYY-MM-DD"),
          };

      setSelectedItem(updatedFilters);
     
      const response = await fetch(
        `${apiUrl}?query=${JSON.stringify(queryPayload)}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Error fetching details: ${response.status}`);
      }

      const result = await response.json();

      const formattedData = result.data.data.map((item, index) => [
        index + 1 + (detailsOffset - 1) * limit,
        item.radiologistName,
        item.vraCount,
        item.modalityCount,
        item.accessionCount,
        item.accessionChangeCount,
        `${item.changePercentage}%`,
        `${item.overallPercentage}%`,
        <Tooltip title="View Details" key={index}>
          <span className="jobType">
            <RemoveRedEyeIcon
              style={{ color: "#E97000", cursor: "pointer" }}
              onClick={() => handleFetchModalityData(item, 0)}
            />
          </span>
        </Tooltip>,
      ]);

      setDetailsData(formattedData);
      setCount(result.data.count);
      setTableView("details");

    } catch (error) {
      console.error("Error fetching details:", error);
      toast.error("Failed to fetch details.");
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  useEffect(() => {
    if (firstRenderModality.current) {
      firstRenderModality.current = false; // Mark first render as done
      return; // Exit effect on first render
    }

    if (modalityOffset !== null) {
      fetchModalityData(filters);
    }
  }, [modalityOffset]);

  const handleFetchModalityData = (items) => {
    setFilters((prevFilters) => {
        const updatedFilters = {
            ...prevFilters,
            radName: items?.radiologistName
                ? { label: items.radiologistName, value: items.radiologistName }
                : prevFilters?.radName,
        };

        fetchModalityData(updatedFilters, items);
        return updatedFilters;
    });
};

  const fetchModalityData = async (updatedFilters,items) => {

    dispatch({ type: "SET_LOADING", payload: true });

    try {
      const apiUrl = `${config.host}/panel/quality-analyzer/data`;

      const queryPayload = isFilterApplied
        ? {
            // offset:newOffset,
            offset: (modalityOffset - 1) * limit,
            limit,
            queryType: "MODALITY",
            practiceName: updatedFilters.practiceName?.label || undefined,
            radiologistName: updatedFilters.radName?.label || undefined,
            modalityName: updatedFilters.modalityName?.label || undefined,
            startDate: updatedFilters.startDate
                ? dayjs(updatedFilters.startDate).format("YYYY-MM-DD")
                : dayjs().subtract(1, "day").format("YYYY-MM-DD"),
            endDate: updatedFilters.endDate
                ? dayjs(updatedFilters.endDate).format("YYYY-MM-DD")
                : dayjs().format("YYYY-MM-DD"),
          }
        : {
            // offset: newOffset,
            payload:false,
            offset: (modalityOffset - 1) * limit,
            limit,
            queryType: "MODALITY",
            practiceName: updatedFilters.practiceName?.label,
            radiologistName: updatedFilters.radName?.label || undefined,
            modalityName: updatedFilters.modalityName?.label || undefined,
            startDate: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
            endDate: dayjs().format("YYYY-MM-DD"),
          };

          setFilters((prevFilters) => ({
            ...prevFilters,
            radName: items?.radiologistName
              ? { label: items.radiologistName, value: items.radiologistName }
              : prevFilters?.radName, 
          }));

      const response = await fetch(
        `${apiUrl}?query=${JSON.stringify(queryPayload)}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Error fetching details: ${response.status}`);
      }

      const result = await response.json();

      const formattedData = result.data.data.map((item, index) => [
        index + 1 + (modalityOffset - 1) * limit,
        item.modalityName,
        item.vraCount,

        item.accessionCount,
        item.accessionChangeCount,
        `${item.changePercentage}%`,
        `${item.overallPercentage}%`,
        <Tooltip title="View Details" key={index}>
          <span className="jobType">
            <RemoveRedEyeIcon
              style={{ color: "#E97000", cursor: "pointer" }}
              onClick={() => handleFetchAccessionData(item, 0)}
            />
          </span>
        </Tooltip>,
      ]);
      setSelectedRad( updatedFilters.radName?.label);
      setModalityData(formattedData);
      setModalityCount(result.data.count);
      setTableView("modality");

    } catch (error) {
      console.error("Error fetching details:", error);
      toast.error("Failed to fetch details.");
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  useEffect(() => {
    if (firstRenderAccession.current) {
      firstRenderAccession.current = false; // Mark first render as done
      return; // Exit effect on first render
    }

    if (accessionOffset !== null) {
      fetchAccessionData(filters);
    }
  }, [accessionOffset]);



  const handleFetchAccessionData = (items) => {
    setModalityOffset(1);
    setFilters((prevFilters) => {
        const updatedFilters = {
            ...prevFilters,
            modalityName: items?.modalityName
                ? { label: items.modalityName, value: items.modalityName }
                : prevFilters?.modalityName,
        };

        fetchAccessionData(updatedFilters, items);
        return updatedFilters;
    });
};


  const fetchAccessionData = async (updatedFilters,items) => {
    setSelectedAccession(items);

    dispatch({ type: "SET_LOADING", payload: true });

    try {
      const apiUrl = `${config.host}/panel/quality-analyzer/data`;

      const queryPayload = isFilterApplied
        ? {
            // offset:newOffset,
            offset: (accessionOffset - 1) * limit,
                  limit,
                  queryType: "ACCESSION",
                  practiceName: updatedFilters.practiceName?.label || undefined,
                  radiologistName: updatedFilters.radName?.label || undefined,
                  modalityName: updatedFilters.modalityName?.label || undefined,
                  startDate: updatedFilters.startDate
                      ? dayjs(updatedFilters.startDate).format("YYYY-MM-DD")
                      : dayjs().subtract(1, "day").format("YYYY-MM-DD"),
                  endDate: updatedFilters.endDate
                      ? dayjs(updatedFilters.endDate).format("YYYY-MM-DD")
                      : dayjs().format("YYYY-MM-DD"),
          }
        : {
            // offset: newOffset,
            offset: (accessionOffset - 1) * limit,
            limit,
            queryType: "ACCESSION",
            practiceName: updatedFilters.practiceName?.label || undefined,
            radiologistName: updatedFilters.radName?.label || undefined,
            modalityName: updatedFilters.modalityName?.label || undefined,
            startDate: updatedFilters.startDate
                ? dayjs(updatedFilters.startDate).format("YYYY-MM-DD")
                : dayjs().subtract(1, "day").format("YYYY-MM-DD"),
            endDate: updatedFilters.endDate
                ? dayjs(updatedFilters.endDate).format("YYYY-MM-DD")
                : dayjs().format("YYYY-MM-DD"),
          };

          setFilters((prevFilters) => ({
            ...prevFilters,
            modalityName: items?.modalityName
              ? { label: items.modalityName, value: items.modalityName }
              : prevFilters?.modalityName, // Keep existing value if missing
          }));

      const response = await fetch(
        `${apiUrl}?query=${JSON.stringify(queryPayload)}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Error fetching details: ${response.status}`);
      }

      const result = await response.json();

      const formattedData = result.data.data.map((item, index) => {
        const serialNo = index + 1 + (accessionOffset - 1) * limit;
        return[
        serialNo,
        item.accessionNumber,
        item.vraName,
        dayjs(item.date).format("YYYY/MM/DD"),
        `${item.accuracyScore}%`,
        item.anyChange,
        item.examChange,
        item.clinicalIndicationChange,
        item.comparisonChange,
        item.techniqueChange,
        item.accessionChangeCount,
        `${item.changePercentage}%`,
        `${item.overallPercentage}%`,
        <span style={{color:item.status === "New"?"red":"green"}}>{item.status}</span>,
        item.isAuditedBySME,
        <Tooltip title="View Details" key={index}>
          <span className="jobType">
            <RemoveRedEyeIcon
              style={{ color: "#E97000", cursor: "pointer" }}
              onClick={() => {
                setSelectedAccessionItem(item)
                setParamsId(item.vraQualityDetailId); // Set paramsId first
                handleOpenModal(item.vraQualityDetailId,serialNo); // Call function after setting paramsId
              }}
            />
          </span>
        </Tooltip>,
      ]});

      setAccessionData(formattedData); // Set transformed data
      setAccessionCount(result.data.count);
      setTableView("ACCESSION");

    } catch (error) {
      console.error("Error fetching details:", error);
      toast.error("Failed to fetch details.");
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handleOpenModal = (id,serialNo) => {
    setParamsId(id);
    setAccessionSno(serialNo);
  };

  useEffect(() => {
    if (paramsId !== null && paramsId !== undefined) {
      setIsModalOpen(true); // Open modal only when paramsId has a valid value
    }
  }, [paramsId]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setParamsId(null);
    
    if (!showFilters) {
      handleFetchAccessionData()
    } else {
      handleApplyFiltersAccession();
    }
  };

  useEffect(() => {
    const fetchMasterData = async () => {
      dispatch({ type: "SET_LOADING", payload: true });

      try {
        setLoading(true);
        const url = `${config.host}/panel/quality-analyzer/master-data`;

        const response = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Error fetching master data");
        }

        const data = await response.json();

        if (data.status === "Ok") {
          setPracticeOptions(
            data.data.practice.map((p) => ({ label: p.practiceName }))
          );
          setRadOptions(
            data.data.radiologist.map((r) => ({ label: r.radiologistName }))
          );
          setModalityOptions(
            data.data.modality.map((m) => ({ label: m.modalitName }))
          );
          setVraOptions(
            data.data.vra.map((v) => ({
              label: v.vraName,
              value: v.vraName,
            })));
        } else {
          console.error("Unexpected response format:", data);
        }
      } catch (error) {
        console.error("Error fetching master data:", error);
      } finally {
        dispatch({ type: "SET_LOADING", payload: false });
      }
    };

    fetchMasterData();
  }, []);

 
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    if (tableView === "Accessionfilter") {
      handleApplyFiltersAccession()
    }
    
  }, [filteraccessionOffset]);

  const handleaccessionfilter=()=>{
    setFilterAccessionOffset(1)
    handleApplyFiltersAccession()
  }


  const handleFilterAccessionChange = (key, value) => {
    setFiltersAccession((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleApplyFilters = () => {

    setAppliedFilters(filters);
    setIsFilterApplied(true);
    setDetailsOffset(1);
  };

  const handleApplyFiltersAccession = async () => {
    const accessionArray = (filtersAccession.accessionNumbers || []).map(
      (item) => item.label
    );
  
    const practiceName = filtersAccession.practiceName?.label || "";
    const radiologistName = filtersAccession.radName?.label || "";
    const modalityName = filtersAccession.modalityName?.label || "";
    const vraArray = (filtersAccession.vraName || []).map(
      (item) => item.label
    );
    const status=filtersAccession.status;
    const isAuditedBySME = filtersAccession.isAuditedBySME
  
    const queryPayload = {
      offset: (filteraccessionOffset - 1) * limit,
      limit,
      accessionArray,
      practiceName,
      radiologistName,
      modalityName,
      vraArray,
      status,
      isAuditedBySME,
      // startDate: filtersAccession.startDate
      //   ? dayjs(filtersAccession.startDate).format("YYYY-MM-DD")
      //   : dayjs().subtract(1, "day").format("YYYY-MM-DD"),
      // endDate: filtersAccession.endDate
      //   ? dayjs(filtersAccession.endDate).format("YYYY-MM-DD")
      //   : dayjs().format("YYYY-MM-DD"),
      ...(filtersAccession.startDate && {
        startDate: dayjs(filtersAccession.startDate).format("YYYY-MM-DD"),
      }),
      ...(filtersAccession.endDate && {
        endDate: dayjs(filtersAccession.endDate).format("YYYY-MM-DD"),
      }),
    };
  
    try {
      dispatch({ type: "SET_LOADING", payload: true });
  
      const response = await fetch(
        `${config.host}/panel/quality-analyzer/accession-data?query=${encodeURIComponent(
          JSON.stringify(queryPayload)
        )}`,
        {
          method: "GET",
          credentials: "include",
        }
      );
  
      const result = await response.json();
  
      if (result?.status === "Ok") {
        const formattedData = result.data.data.map((item, index) => {
          const serialNo = index + 1 + (filteraccessionOffset - 1) * limit;

    return [
         
          serialNo,
          item.accessionNumber,
          item.vraName,
          dayjs(item.date).format("YYYY/MM/DD"),
          item.accuracyScore ? `${item.accuracyScore}%` : "-",
          item.overallPercentage !== null ? `${item.overallPercentage}%` : "-",
          item.anyChange ?? "-",
          item.examChange ?? "-",
          item.clinicalIndicationChange ?? "-",
          item.comparisonChange ?? "-",
          item.techniqueChange ?? "-",
          item.accessionChangeCount ?? "-",
          item.changePercentage ?? "-",
          <span style={{color:item.status === "New"?"red":"green"}}>{item.status}</span>,
          item.isAuditedBySME,
          <Tooltip title="View Details" key={index}>
            <span className="jobType">
              <RemoveRedEyeIcon
                style={{ color: "#E97000", cursor: "pointer" }}
                onClick={() => {
                  setSelectedAccessionItem(item);
                  setParamsId(item.vraQualityDetailId);
                  handleOpenModal(item.vraQualityDetailId,serialNo);
                }}
              />
            </span>
          </Tooltip>,
          
        ];
      });

        setAccessionfilter(true)
        setTableView("Accessionfilter")
        setAccessionData(formattedData);
        setAccessionCount(result.data.count);
      } else {
        console.error("API Error:", result);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };
  
  

  useEffect(() => {
    if (isFilterApplied) {

      switch (tableView) {
        case "main":
          fetchTableData(filters);
          break;
        case "details":
          handleFetchDetailsDataFilters(filters);
          break;
        case "modality":
          fetchModalityData(filters);
          break;
        case "ACCESSION":
          fetchAccessionData(filters);
          break;
        default:
          fetchTableData(filters);
      }

      // setIsFilterApplied(false);
    }
  }, [appliedFilters]);

  const fetchAccessionOptions = async (searchValue) => {
    if (!searchValue) return;
  
    setLoadingAccessions(true);
  
    try {
      const response = await fetch(
        `${config.host}/panel/quality-analyzer/search-accession?query=${encodeURIComponent(
          JSON.stringify({
            offset: 0,
            limit: 10,
            searchValue,
          })
        )}`,
        {
          method: "GET",
          credentials: "include",
        }
      );
  
      const result = await response.json();
  
      if (result?.status === "Ok") {
        const options = result.data.data.map((item) => ({
          label: item.accessionNumber,
          value: item.accessionNumber,
        }));
        setAccessionOptions(options);
      }
    } catch (err) {
      console.error("Failed to fetch accessions", err);
    } finally {
      setLoadingAccessions(false);
    }
  };
  
  // Debounce input to avoid too many API calls
  const debouncedFetch = debounce(fetchAccessionOptions, 300);
  
  useEffect(() => {
    debouncedFetch(inputValue);
    return () => debouncedFetch.cancel();
  }, [inputValue]);

  useEffect(() => {
    if (!isFilterAccession) return;
  
    const fetchAccessionData = async (updatedFilters) => {
      setSelectedAccession(updatedFilters.accessionNumbers); // or any logic you prefer
      
      dispatch({ type: "SET_LOADING", payload: true });
  
      try {
        const apiUrl = `${config.host}/panel/quality-analyzer/data`;
  
        const queryPayload = {
          offset: (accessionOffset - 1) * limit,
          limit,
          queryType: "ACCESSION",
          practiceName: updatedFilters.practiceName?.label || undefined,
          radiologistName: updatedFilters.radName?.label || undefined,
          modalityName: updatedFilters.modalityName?.label || undefined,
          accessionNumbers: updatedFilters.accessionNumbers
          ?.map((item) => item?.value)
          .filter(Boolean),
                    startDate: updatedFilters.startDate
            ? dayjs(updatedFilters.startDate).format("YYYY-MM-DD")
            : dayjs().subtract(1, "day").format("YYYY-MM-DD"),
          endDate: updatedFilters.endDate
            ? dayjs(updatedFilters.endDate).format("YYYY-MM-DD")
            : dayjs().format("YYYY-MM-DD"),
        };
  
        const response = await fetch(
          `${apiUrl}?query=${JSON.stringify(queryPayload)}`,
          {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
  
        if (!response.ok) {
          throw new Error(`Error fetching details: ${response.status}`);
        }
  
        const result = await response.json();
  
        const formattedData = result.data.data.map((item, index) => {
          const serialNo = index + 1 + (accessionOffset - 1) * limit;

          return[
          index + 1 + (accessionOffset - 1) * limit,
          item.accessionNumber,
          item.vraName,
          dayjs(item.date).format("YYYY/MM/DD"),
          `${item.accuracyScore}%`,
          `${item.overallPercentage}%`,
          item.anyChange,
          item.examChange,
          item.clinicalIndicationChange,
          item.comparisonChange,
          item.techniqueChange,
          item.accessionChangeCount,
          item.changePercentage,
          <Tooltip title="View Details" key={index}>
            <span className="jobType">
              <RemoveRedEyeIcon
                style={{ color: "#E97000", cursor: "pointer" }}
                onClick={() => {
                  setSelectedAccessionItem(item);
                  setParamsId(item.vraQualityDetailId);
                  handleOpenModal(item.vraQualityDetailId,serialNo);
                }}
              />
            </span>
          </Tooltip>,
        ]});
  
        setAccessionData(formattedData);
        setAccessionCount(result.data.count);
        setTableView("ACCESSION");
      } catch (error) {
        console.error("Error fetching details:", error);
        toast.error("Failed to fetch details.");
      } finally {
        dispatch({ type: "SET_LOADING", payload: false });
        setIsFilterAccession(false); // ✅ reset flag to prevent repeated calls
      }
    };
  
    fetchAccessionData(filtersAccession); // ✅ Call the function
  
  }, [isFilterAccession]);
  




  // const handleNavigation = () => {
  //   if (tableView === "main") {
  //     navigate("/panel/rpHomePage");
  //   } else if (tableView === "details") {
  //     setDetailsOffset(1);
  //     setModalityOffset(1);
  //     setAccessionOffset(1);
  //     setTableView("main");
  //     setFilters((prevFilters) => ({
  //       ...prevFilters,
  //       practiceName: "",
  //       radName: "",
  //       modalityName: "",
  //     }));
  //   } else if (tableView === "modality") {
  //     setModalityOffset(1);
  //     setTableView("details");
  //     setFilters((prevFilters) => ({
  //       ...prevFilters,
  //       radName: "",
  //       modalityName: "",
  //     }));
  //   } else {
  //     setTableView("modality");
  //     setAccessionOffset(1)
  //     setFilters((prevFilters) => ({
  //       ...prevFilters,
  //       modalityName: "",
  //     }));
  //   }
  // };

  useEffect(()=>{
    if(state?.role?.roleCode){
      if(state?.role?.roleCode === "R001" || state?.role?.roleCode === "R004" || state?.role?.roleCode === "R009" || state?.role?.roleCode === "R010" || state?.role?.roleCode === "R011"){
          setVraFilterAccess(true)
        }
    }
    },[state.role])

  return (
    <div className="quality-dashboard">
      
      {/* Main Content */}
      <div className="dashboard-content">
      <div className="header-container">
      <h1 className="dashboard-title">Quality Dashboard</h1>
     
   
   {tableView === "main" ? (
        <div onClick={() => navigate("/panel/rpHomePage")} className="back-button">
            <img src={leftarrow} alt="Back" />
            <span>Back</span>
        </div>
    ) : tableView === "Accessionfilter" ? (
      <div onClick={() => {setTableView("main"); setAccessionfilter(false);setFilterAccessionOffset(1)}} className="back-button">
          <img src={leftarrow} alt="Back" />
          <span>Back</span>
      </div>
  ) : (
        <div className="breadcrumb-container">
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb"  className="breadcrumb-container">
                <Link color="inherit" onClick={() => handleBreadcrumbClick("main")} sx={{ cursor: "pointer" }}>
                    {filters.practiceName?.label || "Practice"}
                </Link>

                {tableView === "details" ? (
                    <Typography color="text.primary">{filters.radName?.label || "Radiologist"}</Typography>
                ) : (
                    <Link color="inherit" onClick={() => handleBreadcrumbClick("details")} sx={{ cursor: "pointer" }}>
                        {filters.radName?.label || "Radiologist"}
                    </Link>
                )}

                {tableView === "modality" ? (
                    <Typography color="text.primary">{filters.modalityName?.label || "Modality"}</Typography>
                ) : tableView === "ACCESSION" ? (
                    <Link color="inherit" onClick={() => handleBreadcrumbClick("modality")} sx={{ cursor: "pointer" }}>
                        {filters.modalityName?.label || "Modality"}
                    </Link>
                ) : null}

                {tableView === "ACCESSION" && (
                    <Typography color="text.primary">Accession</Typography>
                )}
            </Breadcrumbs>
        </div>
    )}
</div>

{tableView === "Accessionfilter" ? (
  <div>
    <ReusableTable
      data={accessionData ?? []}
      count={accessioncount}
      offset={filteraccessionOffset}
      setOffset={(newOffset) => setFilterAccessionOffset(newOffset)}
      limit={limit}
      setSearchValue={setSearchValue}
      heading={[
        "S.No",
        "Accession Number",
        "VRA Name",
        "Date",
        "Accuracy Score",
        "Deviation Percentage",
        "Any Change",
        "Exam Change",
        "Clinical Indication Change",
        "Comparison Change",
        "Technique Change",
        "Accession Count with Changes",
        "Change Percentage",
        "Status",
        "Audited By SME",
        "View",
      ]}
    />
  </div>
) : (
  <>
        
        {tableView === "main" ? (
          <ReusableTable
            data={Array.isArray(tableDataModal) ? tableDataModal : []}
            count={count} // Total records count
            offset={offset} // Current offset
            setOffset={setOffset} // Function to update offset
            limit={limit} // Number of records per page
            setSearchValue={setSearchValue} // Function to update search
            heading={[
              "S.No",
              "Practice Name",
              "Radiologist Count",
              "VRA Count",
              "Modality Count",
              "Accession Count",
              "Accession Count with Changes",
              "Change Percentage",
              "Deviation Percentage",
              "View",
            ]}
          />
        ) : tableView === "details" ? (
          <div>
            <ReusableTable
              data={detailsData?detailsData:[]}
              count={count}
              offset={detailsOffset}
              setOffset={(newOffset) => {
                setDetailsOffset(newOffset);
              }}
              limit={limit}
              setSearchValue={setSearchValue}
              heading={[
                "S.No",
                "Radiologist Name",
                "VRA Count",
                "Modality Count",
                "Accession Count",
                "Accession Count with Changes",
                "Change Percentage",
                "Deviation Percentage",
                "View",
              ]}
            />
          </div>
        ) : tableView === "modality" ? (
          <div>
            <ReusableTable
              data={modalityData?modalityData:[]}
              count={modalitycount}
              offset={modalityOffset}
              setOffset={(newOffset) => {
                setModalityOffset(newOffset);
              }}
              limit={limit}
              setSearchValue={setSearchValue}
              heading={[
                "S.No",
                "Modality Name",
                "VRA Count",
                "Accession Count",
                "Accession Count with Changes",
                "Change Percentage",
                "Deviation Percentage",
                "View",
              ]}
            />
          </div>
        ) : (
          <div>
            <ReusableTable
              data={accessionData?accessionData:[]}
              count={accessioncount}
              offset={accessionOffset}
              setOffset={(newOffset) => {
                setAccessionOffset(newOffset);
              }}
              limit={limit}
              setSearchValue={setSearchValue}
              heading={[
                "S.No",
                "Accession Number",
                "VRA Name",
                "Date",
                "Accuracy Score",
                "Any Change",
                "Exam Change",
                "Clinical Indication Change",
                "Comparison Change",
                "Technique Change",
                "Accession Count with Changes",
                "Change Percentage",
                "Deviation Percentage",
                "Status",
                "Audited By SME",
                "View",
              ]}
            />
            
          </div>
        )}


  </>
)}
        
      </div>
      

      {/* Filters Section (Bottom) */}
      <div className="filters-container">
      <Grid container spacing={2}>
    <Grid item xs={12}>
      <FormControlLabel
        control={
          <Switch
            checked={showFilters}
            onChange={(e) =>{ setShowFilters(e.target.checked)
              setFilterAccessionOffset(1)
              if (tableView === "Accessionfilter") {
                setTableView("main");
              }
             }}
           
            color="primary"
          />
        }
        label={showFilters ? "Filters ON" : "Filters OFF"}
        labelPlacement="end"
      />
    </Grid>
    {!showFilters ? (
      <>
      <Grid item xs={12} md={9}>
    <Grid container spacing={2}>
      {/* First row - 3 inputs */}
      <Grid item xs={12} sm={4}>
          <Autocomplete
            className="filter-item"
            options={practiceOptions}
            value={filters.practiceName}
            onChange={(event, newValue) =>
              handleFilterChange("practiceName", newValue)
            }
            getOptionLabel={(option) => option?.label || ""}
            renderInput={(params) => (
              <TextField {...params} label="Practice Name" variant="outlined" />
            )}
            disabled={
              tableView == "details" ||
              tableView == "modality" ||
              tableView == "ACCESSION"
            }
          />
           </Grid>

           <Grid item xs={12} sm={4}>
          <Autocomplete
            className="filter-item"
            options={radOptions}
            value={filters.radName}
            onChange={(event, newValue) =>
              handleFilterChange("radName", newValue)
            }
            renderInput={(params) => (
              <TextField {...params} label="RAD Name" variant="outlined" />
            )}
            disabled={tableView == "modality" || tableView == "ACCESSION"}
          />
            </Grid>

            <Grid item xs={12} sm={4}>
          <Autocomplete
            className="filter-item"
            options={modalityOptions}
            value={filters.modalityName}
            onChange={(event, newValue) =>
              handleFilterChange("modalityName", newValue)
            }
            getOptionLabel={(option) => option?.label || ""}
            isOptionEqualToValue={(option, value) =>
              option.label === value?.label
            }
            renderInput={(params) => (
              <TextField {...params} label="Modality Name" variant="outlined" />
            )}
            disabled={tableView == "ACCESSION"}
          />
            </Grid>
            <Grid item xs={12} sm={4}>
        
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              className="filter-item"
              label="Start Date"
              value={filters.startDate}
              onChange={(newValue) =>
                handleFilterChange("startDate", dayjs(newValue))
              }
              renderInput={(params) => (
                <TextField {...params} variant="outlined" size="small"/>
              )}
            />
          </LocalizationProvider>
         
          </Grid>

          <Grid item xs={12} sm={4}>
          
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              className="filter-item"
              label="End Date"
              value={filters.endDate}
              onChange={(newValue) =>
                handleFilterChange("endDate", dayjs(newValue))
              }
              renderInput={(params) => (
                <TextField {...params} variant="outlined" size="small" />
              )}
            />
          </LocalizationProvider>
          
          </Grid>
    </Grid>
  </Grid>
  <Grid item xs={12} md={3} display="flex" justifyContent="flex-end" alignItems="flex-end">
            <Button
              variant="contained"
              color="primary"
              onClick={handleApplyFilters}
            >
              Apply Filters
            </Button>
            </Grid>
            </>
          ) : <>
          <Grid item xs={12} md={9}>
        <Grid container spacing={2}>
          {/* First row - 3 inputs */}
          <Grid item xs={12} sm={4}>
          <Box sx={{ width: '80%' }}>
              <Autocomplete
                className="filter-item"
                options={practiceOptions}
                value={filtersAccession.practiceName}
                onChange={(event, newValue) =>
                  handleFilterAccessionChange("practiceName", newValue)
                }
                getOptionLabel={(option) => option?.label || ""}
                renderInput={(params) => (
                  <TextField {...params} label="Practice Name" variant="outlined" />
                )}
              
              />
               </Box>
               </Grid>
    
               <Grid item xs={12} sm={4}>
               <Box sx={{ width: '80%' }}>
              <Autocomplete
                className="filter-item"
                options={radOptions}
                value={filtersAccession.radName}
                onChange={(event, newValue) =>
                  handleFilterAccessionChange("radName", newValue)
                }
                renderInput={(params) => (
                  <TextField {...params} label="RAD Name" variant="outlined" />
                )}
              />
               </Box>
                </Grid>
    
                <Grid item xs={12} sm={4}>
                <Box sx={{ width: '80%' }}>
              <Autocomplete
                className="filter-item"
                options={modalityOptions}
                value={filtersAccession.modalityName}
                onChange={(event, newValue) =>
                  handleFilterAccessionChange("modalityName", newValue)
                }
                getOptionLabel={(option) => option?.label || ""}
                isOptionEqualToValue={(option, value) =>
                  option.label === value?.label
                }
                renderInput={(params) => (
                  <TextField {...params} label="Modality Name" variant="outlined" />
                )}
              />
               </Box>
                </Grid>

                <Grid item xs={12} sm={4}>
                <Box sx={{ width: '80%' }}>
  <Autocomplete
    multiple
    disableCloseOnSelect
    options={accessionOptions}
    value={filtersAccession.accessionNumbers || []}
    onChange={(event, newValue) =>
      handleFilterAccessionChange("accessionNumbers", newValue)
    }
    onInputChange={(event, newInputValue) => {
      setInputValue(newInputValue);
    }}
    filterOptions={(x) => x} // prevent client-side filtering
    getOptionLabel={(option) => option?.label || ""}
    isOptionEqualToValue={(option, value) => option.value === value?.value}
    loading={loadingAccessions}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Accession"
        variant="outlined"
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {loadingAccessions ? (
                <CircularProgress color="inherit" size={20} />
              ) : null}
              {params.InputProps.endAdornment}
            </>
          ),
        }}
      />
    
    )}
  />
  </Box>
</Grid>
              

{vraFilterAccess && <Grid item xs={12} sm={4}>
  <Box sx={{ width: '80%' }}>
  <Autocomplete
  multiple
  disableCloseOnSelect
  options={vraOptions}
  value={filtersAccession.vraName || []}
  onChange={(event, newValue) =>
    handleFilterAccessionChange("vraName", newValue)
  }
  getOptionLabel={(option) => option.label}
  isOptionEqualToValue={(option, value) => option.value === value.value}
  renderInput={(params) => (
    <TextField {...params} label="VRA Name" variant="outlined" />
  )}
/>
  </Box>
</Grid>}

<Grid item xs={12} sm={4}>
  <Box sx={{ width: '80%' }}>
    <Autocomplete
      options={statusOptions}
      value={filtersAccession.status}
      disableClearable
      onChange={(event, newValue) =>
        setFiltersAccession((prev) => ({
          ...prev,
          status: newValue,
        }))
      }
      renderInput={(params) => (
        <TextField {...params} label="Status" variant="outlined" />
      )}
    />
  </Box>
</Grid>

<Grid item xs={12} sm={4}>
  <Box sx={{ width: '80%' }}>
    <Autocomplete
      options={isAuditedBySME}
      value={filtersAccession.isAuditedBySME}
      disableClearable
      onChange={(event, newValue) =>
        setFiltersAccession((prev) => ({
          ...prev,
          isAuditedBySME: newValue,
        }))
      }
      renderInput={(params) => (
        <TextField {...params} label="Audited By SME" variant="outlined" />
      )}
    />
  </Box>
</Grid>


              
        </Grid>
      </Grid>
      <Grid item xs={12} md={3} display="flex" justifyContent="flex-end" alignItems="flex-end">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleaccessionfilter}
                >
                  Apply
                </Button>
                </Grid>
                </>}
        </Grid>
      </div>
     

      <Dialog open={isModalOpen} onClose={handleCloseModal} fullScreen>
        <DialogContent sx={{p: 0}}>
        <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            sx={{ position: "absolute", right: 25, top: 8 , border:"2px solid"}}
          >
            <CloseIcon />
          </IconButton><QualityDetails  handleApplyFiltersAccession={handleApplyFiltersAccession} accessioncount={accessioncount} offset={accessionSno} paramsIds={paramsId} filterapplied={showFilters === true} accessionfilter={filtersAccession} filters={filters} accessionData={selectedAccessionItem} onClose={handleCloseModal}/>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default QualityDashboard;
